import { Button, Card, CardContent, CardActions } from "@mui/material";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";


function Offers() {
const navigate = useNavigate();


return (
<div className="min-h-screen w-full flex justify-center items-center bg-gradient-to-br from-gray-100 to-gray-200 p-4">
  <Outlet />
</div>
);
}


export default Offers;